// eslint-disable-next-line import/prefer-default-export
export const DRAWER_WIDTH = {
  OPEN: 320,
  CLOSED: 80,
};
